import { Box } from "@mui/material";

export const BeaconLogo: React.FC = () => {

    return (
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <Box sx={{ display: "flex", flexDirection: 'row', justifyContent: "center", alignItems: "center"}}>
                <img src="/beacon-logo.svg" alt="Business Logo" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
            </Box>
        </Box>
    );
};